import React from 'react';

import MapContainer from '../container/MapContainer';
import MapContainerCabinet from '../container/MapContainerCabinet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faAddressBook } from '@fortawesome/free-solid-svg-icons';






const ContactDetails = () => {
    return (
        <div style={{ paddingTop: '100px' }}>
            <div className="container mt-5">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="hero_figure">

                            <img className="imgpage" src="assets/img/contact_reflexology_new.png" alt="Réflexologie" />

                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="hero_content">

                            <div className="mb-5">
                                <span className="top-title">Toutes les séances sont sur rendez-vous</span>
                                <br></br>
                                <span className="top-descript">Veuillez annuler 48h avant votre rendez-vous</span>
                                <br></br>


                                <ul className="horloge">
                                    <li><h1 className="top-list">Les Mercredis et Samedi de 9h00 à 19h00</h1></li>

                                </ul>


                                <br></br>
                                <span className="top-descript">Pour me contacter:</span>
                                <br></br>
                                <p className="social-container">
                                    <a href="tel:+33622111569" ><FontAwesomeIcon icon={faPhone} size="2x" />+33 6 22 11 15 69</a>
                                    <br></br>
                                    <a href="mailto:nive.ramarovelo.reflexologue@gmail.com"><FontAwesomeIcon icon={faEnvelope} size="2x" /> nive.ramarovelo.reflexologue@gmail.com</a>
                                </p>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="container mt-4">
                <div className="row text-center">
                    <div className="col-lg-6 offset-lg-3">
                        <div className="about_header mb-5">
                            <span className="top-title">Informations pratiques </span>
                            <p>Membre de la Fédération Française de Réflexologie</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container mb-5">
                <div className="row mb-4">
                    <div className="col-12 text-center text-lg-start">
                        <h1 className="top-title">Le Cabinet de Réflexologie Plantaire</h1>
                        <div className="address-container">
                            <FontAwesomeIcon icon={faAddressBook} size="lg" className="me-2" style={{ color: '#10796a' }} />
                            <span>54 Avenue Jean Moulin, 92390 Villeneuve-La-Garenne</span>
                        </div>
                    </div>
                </div>
                <div className="row align-items-start">
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <img src="assets/img/img_cabinet.jpg" className="img-fluid img-cabinet" alt="Cabinet" />
                    </div>
                    <div className="col-lg-6">
                        <MapContainerCabinet />
                    </div>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
            </div>
        </div>
    );
}

export default ContactDetails;